module.exports = __webpack_public_path__ + "img/l-banner-guide.5dfa291d.png";